import { makeWorkbook } from "../../utils/excel";
import { getIndicatorPayments } from "../../../../../../rest/indicator";

export async function buildWorkbookPayments() {
  const resp = await getIndicatorPayments();
  const payload = resp?.data || {};
  const payments = Array.isArray(payload?.data) ? payload.data[0] : payload?.data || {};
  const inv = payments?.investmentBreakdown || {};
  const ws  = payments?.workstationsBreakdown || {};

  const resumoAoa = [
    ["Indicador", "Valor"],
    ["Total aprovado", Number(payments?.totalApproved || 0)],
    ["Total aprovado para investimento", Number(payments?.totalApprovedInvestment || 0)],
    ["Total aprovado para criação do próprio emprego", Number(payments?.totalApprovedWorkstations || 0)],
    ["Total pago", Number(payments?.totalPaid || 0)],
    ["Pago - Investimento (Total)", Number(inv?.total || 0)],
    ["Pago - Investimento (Adiantamento)", Number(inv?.advance || 0)],
    ["Pago - Investimento (Encerramento)", Number(inv?.closure || 0)],
    ["Pago - Investimento (Compensatório)", Number(inv?.compensatory || 0)],
    ["Pago - Criação do próprio emprego (Total)", Number(ws?.total || 0)],
    ["Pago - Criação do próprio emprego (Adiantamento)", Number(ws?.advance || 0)],
    ["Pago - Criação do próprio emprego (Encerramento)", Number(ws?.closure || 0)],
    ["Pago - Criação do próprio emprego (Compensatório)", Number(ws?.compensatory || 0)],
  ];

  const aprovadoAoa = [
    ["Descrição", "Valor"],
    ["Total aprovado", Number(payments?.totalApproved || 0)],
    ["Total aprovado para investimento", Number(payments?.totalApprovedInvestment || 0)],
    ["Total aprovado para criação do próprio emprego", Number(payments?.totalApprovedWorkstations || 0)],
  ];

  const pagoAoa = [
    ["Descrição", "Valor"],
    ["Total pago", Number(payments?.totalPaid || 0)],
    [],
    ["Investimento (Total)", Number(inv?.total || 0)],
    ["Investimento - Adiantamento", Number(inv?.advance || 0)],
    ["Investimento - Encerramento", Number(inv?.closure || 0)],
    ["Investimento - Compensatório", Number(inv?.compensatory || 0)],
    [],
    ["Criação do próprio emprego (Total)", Number(ws?.total || 0)],
    ["Criação do próprio emprego - Adiantamento", Number(ws?.advance || 0)],
    ["Criação do próprio emprego - Encerramento", Number(ws?.closure || 0)],
    ["Criação do próprio emprego - Compensatório", Number(ws?.compensatory || 0)],
  ];

  const wb = makeWorkbook([
    { name: "Resumo",  aoa: resumoAoa },
    { name: "Aprovado", aoa: aprovadoAoa },
    { name: "Pago",     aoa: pagoAoa },
  ]);

  return wb;
}
